import { render, staticRenderFns } from "./PatientDetailModal.vue?vue&type=template&id=5fd864db&scoped=true"
import script from "./PatientDetailModal.vue?vue&type=script&lang=js"
export * from "./PatientDetailModal.vue?vue&type=script&lang=js"
import style0 from "./PatientDetailModal.vue?vue&type=style&index=0&id=5fd864db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd864db",
  null
  
)

export default component.exports